import type { Alias } from '@swf/core/models/cms';
import type { MeetingBasedEventTypeId } from '@swf/generated/types/api/sports';

import { EventTypeId } from '../types/eventType';

import { isMeetingBasedEventTypeId } from './isEventTypeId';

const GREYHOUND_RACING_ROUTING_KEYS = new Set<Alias | null>([
  'sportsGreyhoundRacingMeetings',
  'sportsGreyhoundRacingNext',
  'sportsGreyhoundRacingRace',
  'sportsGreyhoundRacingFuture',
  'sportsGreyhoundRacingFutureMarket'
]);

const HORSE_RACING_ROUTING_KEYS = new Set<Alias | null>([
  'sportsHorseRacingMeetings',
  'sportsHorseRacingNext',
  'sportsHorseRacingRace',
  'sportsHorseRacingFuture',
  'sportsHorseRacingFutureMarket'
]);

export const isGreyhoundRacingRoutingKey = (alias?: Alias | null) =>
  alias && GREYHOUND_RACING_ROUTING_KEYS.has(alias);

export const isHorseRacingRoutingKey = (alias?: Alias | null) =>
  alias && HORSE_RACING_ROUTING_KEYS.has(alias);

export const isAnimalRacingRoutingKey = (alias?: Alias | null) =>
  isGreyhoundRacingRoutingKey(alias) || isHorseRacingRoutingKey(alias);

/**
 * Takes an Alias and eventTypeId and returns a meeting based eventTypeId
 */
const deriveMeetingBasedEventTypeId = (
  activeRoute?: Alias | null,
  configuredEventTypeId?: string
): MeetingBasedEventTypeId => {
  if (configuredEventTypeId && isMeetingBasedEventTypeId(Number(configuredEventTypeId))) {
    return Number(configuredEventTypeId) as MeetingBasedEventTypeId;
  }

  if (isGreyhoundRacingRoutingKey(activeRoute)) {
    return EventTypeId.GREYHOUND_RACING;
  }

  return EventTypeId.HORSE_RACING;
};

export default deriveMeetingBasedEventTypeId;
